module.exports = __webpack_public_path__ + "img/antes_despues_97.abd3311a.png";